import { render, staticRenderFns } from "./GroupsTableSample.vue?vue&type=template&id=74ada234&"
import script from "./GroupsTableSample.vue?vue&type=script&lang=js&"
export * from "./GroupsTableSample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports